import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { MenuActions } from './menu.actions';
import { MenuType } from './menu.state';
import { PanelActions } from '../panel/panel.actions';
import { PanelSelectors } from '../panel/panel.selectors';
import { PanelViewId } from '../panel/panel.state';
import { ExtractActions } from '../extract/extract.actions';
import { RootState } from '../root-state.model';

@Injectable()
export class MenuEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject<Store<RootState>>(Store);

  public syncDealMenuWithJsonEditor$ = createEffect(() =>
    this.store.select(PanelSelectors.showJsonEditor).pipe(
      distinctUntilChanged(),
      map((open) => MenuActions.SelectMenu({ menu: open ? MenuType.DealEditor : MenuType.Deal })),
    ),
  );

  public closeJsonEditorOnDealMenuSelect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MenuActions.SelectMenu),
      filter(({ menu }) => menu === MenuType.Deal),
      withLatestFrom(this.store.select(PanelSelectors.showJsonEditor)),
      filter(([, jsonEditorOpen]) => jsonEditorOpen),
      mergeMap(() => [
        PanelActions.PatchCalculatedViewerState({
          patch: [{ panel: PanelViewId.JSONEditor, show: false }],
        }),
        ExtractActions.UpdateSelectedDatapointForEdit(undefined),
      ]),
    ),
  );
}
